export * from './TileChart';
import TileChart from './TileChart';
export default TileChart;
